module.exports = __webpack_public_path__ + "static/media/logo-big.2ffd40c1.svg";